"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicPrizeContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const utils_1 = require("../utils");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
const ZWinningCriterion = zod_1.z.object({
    tier: zod_1.z.string(),
    matchesRequired: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    isBoostRequired: zod_1.z.boolean(),
});
const ZGetWinningCriteriaOfPrizeResponseV2 = zod_1.z.record(zod_1.z.string(), zod_1.z.record(zod_1.z.string(), ZWinningCriterion));
const ZGetAllAvailablePrizesResponse = models_1.ZPrizeCore.extend({
    categories: zod_1.z.string().array(),
    tierCode: zod_1.z.string(),
    tierValue: zod_1.z.number().nullable(),
    drawTypePlans: zod_1.z.string().array(),
}).array();
const ZGetAvailablePrizeTiersResponse = zod_1.z.string().array();
const ZGetCategoriesResponse = zod_1.z.record(zod_1.z.string(), zod_1.z.string().array());
const ZGetPrizeBySlugResponse = models_1.ZPrizeSelect.pick({
    id: true,
    title: true,
    subheading: true,
    type: true,
    slug: true,
    imageLocations: true,
    overviewBody: true,
    whatsIncludedHeading: true,
    whatsIncludedBody: true,
    seoMetaTitle: true,
    seoMetaDescription: true,
    seoKeywords: true,
    seoImageAltText: true,
    isFromPlayersSuggestion: true,
    subscriberDiscountContentCode: true,
}).extend({
    visible: zod_1.z.boolean(),
    products: zod_1.z.array(models_1.ZProductSelect.pick({
        id: true,
        name: true,
        description: true,
        imageLocation: true,
    })),
    categories: zod_1.z.string().array(),
});
const ZGetPrizeBySlugResponseV2 = ZGetPrizeBySlugResponse.extend({
    winningCriteria: ZGetWinningCriteriaOfPrizeResponseV2,
});
const ZSimilarPrize = models_1.ZPrizeSelect.pick({
    id: true,
    title: true,
    subheading: true,
    slug: true,
}).extend({
    heroImageLocation: zod_1.z.string(),
});
const ZGetSimilarPrizesResponse = ZSimilarPrize.array();
exports.publicPrizeContract = c.router({
    getAllAvailablePrizesV2: {
        method: 'GET',
        path: '/get-all-available-prizes-v2',
        query: zod_1.z.object({
            drawTypeCode: zod_1.z.string(),
            drawScheduleCode: zod_1.z.string(),
        }),
        responses: {
            200: ZGetAllAvailablePrizesResponse,
        },
        summary: 'Get all available prizes for prizes page, includes prize tiers and relevant draw type plans',
    },
    getAvailablePrizeTiersV2: {
        method: 'GET',
        path: '/get-available-prize-tiers-v2',
        query: zod_1.z.object({
            drawTypeCode: zod_1.z.string(),
            drawScheduleCode: zod_1.z.string(),
        }),
        responses: {
            200: ZGetAvailablePrizeTiersResponse,
            404: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
        summary: 'Get all available prize tiers for a draw schedule',
    },
    getCategories: {
        method: 'GET',
        path: '/get-categories',
        responses: {
            200: ZGetCategoriesResponse,
            404: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
        summary: 'Get categories for prizes page, includes only active categories and those with more than a pre-defined number of prizes',
    },
    getPrizeBySlugV2: {
        method: 'GET',
        path: '/get-prize-by-slug-v2',
        query: zod_1.z.object({
            slug: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                prize: ZGetPrizeBySlugResponseV2,
            }),
            404: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
        summary: 'Get a prize for prize details page, includes prize tiers and winning criteria',
    },
    getSimilarPrizes: {
        method: 'GET',
        path: '/get-similar-prizes',
        query: zod_1.z.object({
            prizeId: zod_1.z.coerce.number(),
        }),
        responses: {
            200: ZGetSimilarPrizesResponse,
        },
        summary: 'Get similar prizes for recommendation',
    },
    getDashboardPrizes: {
        method: 'GET',
        path: '/dashboard',
        responses: {
            200: models_1.ZDashboardPrize.array(),
        },
        summary: 'Get dashboard prizes for recommendation',
    },
    incrementPrizeViewCount: {
        method: 'PATCH',
        path: '/increment-prize-view-count',
        body: zod_1.z.object({
            slug: zod_1.z.string(),
        }),
        responses: {
            200: utils_1.successSchema,
            404: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
    },
}, {
    pathPrefix: '/public',
});
//# sourceMappingURL=prize.public.contract.js.map